<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Project Spectrum Event Details'"
        />
        <router-link :to="{ 
          name: 'events', 
          query: { 
            eventPage: eventPage, 
            query: query, 
            eventType: eventType 
          }
        }">
          <v-btn
            rounded
            large
            dark
            :color="'#424EC4'"
          >
            Back to All Events
          </v-btn>
        </router-link>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- Social Media Section Start -->
    <SocialMediaWidgets
      :title="title"
      :description="description"
      :type="'news'"
    />
    <!-- Social Media Section End -->

    <!-- Cyber Circuit Event Details Start-->
    <section class="section section-blog p-0 mb-3">
      <div class="container-fluid px-xs-3 px-sm-3 px-md-5 px-lg-5 px-xl-5 my-3">
        <div class="row">
          <div class="col-12 col-lg-6 col-xl-6">
            <div class="image-container">
              <img
                :src="item?.cyberBannerLink"
                :alt="item?.photoDescription"
                class="image-content"
              />
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xl-6">
            <div class="event-details">
              <div class="w-100 d-flex flex-row justify-content-start py-2 event-text event-header-text">
                {{ item?.title }}
              </div>
              <div v-if="isMobile" class="w-100 d-flex flex-row justify-content-start pb-2 event-text event-header-text">
                {{ `${formatDate(item?.date)} ${formatTime(item?.date)}` }}
              </div>
              <div class="w-100 py-3 d-flex flex-column justify-content-start align-items-start event-description">
                <span class="text-left" v-html="item?.article"></span>
              </div>
              <div v-if="!isMobile" class="my-2 d-flex flex-column justify-content-start">
                <div style="height: 25px;" class="w-100 text-start event-header-text">
                  DATE
                </div>
                <div style="height: 25px;" class="w-100 text-start event-header-content">
                  {{ formatDate(item?.date) }}
                </div>
              </div>
              <div v-if="!isMobile" class="my-2 d-flex flex-column justify-content-start">
                <div style="height: 25px;" class="w-100 text-start event-header-text">
                  TIME
                </div>
                <div style="height: 25px;" class="w-100 text-start event-header-content">
                  {{ formatTime(item?.date) }}
                </div>
              </div>
            </div>

            <div v-if="(new Date(item?.date) <= Date.now())" class="row my-2">
              <div v-if="item.cyberPowerpointLink" class="col-12 col-lg-6 col-xl-6">
                <a 
                  :href="item?.cyberPowerpointLink"
                  variant="link"
                  target="_blank"
                  class="btn theme-btn w-100 rounded centered-link"
                >
                  PowerPoint
                </a>
              </div>
              <div v-if="item.cyberRecordingLink" class="col-12 col-lg-6 col-xl-6">
                <a 
                  :href="item?.cyberRecordingLink"
                  variant="link"
                  target="_blank"
                  class="btn theme-btn w-100 rounded centered-link"
                >
                  Recording
                </a>
              </div>
            </div>

            <div v-if="(new Date(item?.date) > Date.now())" class="row my-2">
              <div v-if="item?.cyberCalendarLink != ''" class="col-12 col-lg-6 col-xl-6">
                <a
                  :href="item?.cyberCalendarLink"
                  variant="link"
                  target="_blank"
                  class="btn theme-btn w-100 rounded centered-link"
                >
                  Register
                </a>
              </div>
              <div v-if="item.cyberCalendarLink === ''" class="col-12 col-lg-6 col-xl-6">
                <a
                  :href="item?.cyberCalendarLink"
                  variant="link"
                  target="_blank"
                  class="btn theme-btn w-100 rounded centered-link disabled"
                >
                  Calender
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Cyber Circuit Event Details Section End-->
  </div>
</template>
<script>
import { BFormInput } from 'bootstrap-vue';
import axios from 'axios';
import moment from 'moment';
import SocialMediaWidgets from '../library/widgets/social-media-widgets.vue';
import PageHeader from '../library/widgets/page-header.vue';
import PageHeaderTitleContent from '../library/widgets/page-header-title-content.vue';
import TitleTextContent from '../library/widgets/title-text-content.vue';

export default {
  name: 'cyber-circuits-detail',
  components: {
    BFormInput,
    SocialMediaWidgets,
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  props: {
    id: String,
    eventPage: String,
    query: String,
    eventType: String
  },
  data() {
    return {
      item: {},
      categories: [
        { name: 'Cyber Security', articles: 4 },
        { name: 'Software', articles: 5 },
        { name: 'Manufacturing', articles: 6 },
        { name: 'Learning Tools', articles: 7 },
      ],
      archives: [
        { name: 'February 2020', articles: 4 },
        { name: 'January 2020', articles: 5 },
        { name: 'June 2020', articles: 6 },
        { name: 'May 2020', articles: 7 },
      ],
      tags: [
        { name: 'Development' },
        { name: 'Security' },
        { name: 'Infrastructure' },
        { name: 'Androids' },
        { name: 'Phishing' },
        { name: 'Coronavirus' },
      ],
      linkCopyText: 'Click to copy url link',
    };
  },
  async created() {
    if (this.id) {
      this.item = await this.getResource(this.id);
    } else {
      this.$router.push({ path: 'cyber-circuits' });
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    title() {
      return this.item?.title || 'Title';
    },
    description() {
      return this.item?.headLine || 'HeadLine';
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
    async getResource(id) {
      /*  API call to server: GET /api/resources/blogs */
      axios
        .get(`/api/resources/cybercircuits/${id}`)
        .then((response) => {
          if (response.data.Items.length > 0) {
            /** Does an item exist for the query id */
            this.item = response.data.Items[0];
            //console.log(response.data);
          } else {
            /** If no item exists with the id, redirect to list*/
            this.$router.push({ path: 'cyber-circuits' });
          }
        })
        .catch((error) => {
          /** On error, redirect back to list */
          console.error(error);
          this.$router.push({ path: 'cyber-circuits' });
        });
    },
    formatDate(eventDate) {
      return moment(eventDate).format('MM/DD/YYYY');
    },
    formatTime(eventDate) {
      return moment(eventDate).format('hh:mm A');
    },
  },
};
</script>
<style scoped>
.inner-header-bg {
  background-image: url('~@/assets/images/headers/events.png');
  background-position: center center;
}
.centered-link {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  width: 100%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
}
.image-content {
  width: 100%;
  height: auto;
}
.event-details {
  width: 100%;
  min-height: auto;
}
.event-description {
  min-height: 100px;
}
.event-text {
  color: #000;
  font-family: Rajdhani;
  font-style: normal;
  line-height: 20px;
}
.event-header-text {
  font-size: 20px;
  font-weight: 700;
}
.event-header-content {
  font-size: 18px;
  font-weight: 400;
}
</style>
